module.exports = __webpack_public_path__ + "d0191f20143156bca4117967f67e18ff.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VA.svg
// module id = 2pJ7
// module chunks = 0